/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const DURATION = feature.getSettingValue('DURATION');
    const NAME = `delay_${feature.getID()}`;
    const startLinks = project.getNodeLinks(feature, 'delay_start');
    const elapsedLinks = project.getNodeLinks(feature, 'delay_elapsed');

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        id: 'delay_has_active',
        template: 'dim delay_has_active as boolean=false',
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: 'declare_delay_has_active',
        template: `
declare delay_has_active as boolean
declare sub delay_handler()
`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        id: `${NAME}`,
        template: `dim ${NAME} as dword=0`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `declare_${NAME}`,
        template: `
declare ${NAME} as dword
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'delay_handler',
        template: `
sub delay_handler()
    if delay_has_active then
        dim delay_count as byte=0
        dim sys_timer_count_ms as dword=sys.timercountms
        '****delay_handler****'
        
        if delay_count=0 AND delay_has_active = false then
            delay_has_active = false
        end if
    end if
end sub
        `,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        id: 'delay_handler_call',
        template: `
delay_handler()
`,
    });

    if (elapsedLinks.length > 0) {
        const link = elapsedLinks[0];


        blocks.push({
            location: 'delay_handler',
            blockType: BlockType.CODE,
            id: `delay_elapsed_${link.getSourceId()}`,
            template: `
    if ${NAME} > 0 then
        if sys_timer_count_ms > ${NAME} then
            ${NAME} = 0
            '****${link.getSourceId()}****'
        else
            delay_count = delay_count + 1
        end if
    end if`,
        });
    }

    if (startLinks.length > 0) {
        for (let i = 0; i < startLinks.length; i++) {
            const link = startLinks[i];
            const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
            const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
            const duration = project
                .parseCodeExpression(DURATION, sourceParams, TibboDataType.FLOAT);
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
delay_has_active = true
${NAME}=sys.timercountms + ${duration} * 1000
    `,
            });
        }
    }
    return blocks;
};
